module.exports = __webpack_public_path__ + "static/media/ag-hoodie3.98beac5b.jpg";